'use client';

import React from 'react';
import { FormattedNumberInput } from '@/components/ui/FormattedNumberInput';

export const CalculatorForm = ({ formData, handleInputChange }) => {
  return (
    <div className="grid md:grid-cols-2 md:gap-8">
      <div className="mb-8 lg:mb-0">
        <label htmlFor="propertyValue" className="text-[#0C0D1A] text-base font-medium pt-10 mb-2 block">
          Property value
        </label>
        <FormattedNumberInput
          name="propertyValue"
          value={formData.propertyValue}
          onChange={handleInputChange}
          prefix="£"
          ariaLabel="Property value in pounds"
        />
      </div>

      <div className="mb-8 lg:mb-0">
        <label htmlFor="initialAdvance" className="text-[#0C0D1A] text-base font-medium md:pt-10 mb-2 block">
          Initial advance
        </label>
        <FormattedNumberInput
          name="initialAdvance"
          value={formData.initialAdvance}
          onChange={handleInputChange}
          prefix="£"
          ariaLabel="Initial advance in pounds"
        />
      </div>

      <div className="mb-8 lg:mb-0">
        <label htmlFor="interestRate" className="text-[#0C0D1A] text-base font-medium mb-2 block">
          Interest rate (MER):
        </label>
        <FormattedNumberInput
          name="interestRate"
          value={formData.interestRate}
          onChange={handleInputChange}
          prefix="%"
          ariaLabel="Interest rate percentage"
        />
      </div>

      <div className="mb-8">
        <label htmlFor="annualHousePriceChange" className="text-[#0C0D1A] text-base font-medium mb-2 block">
          Annual house price change:
        </label>
        <FormattedNumberInput
          name="annualHousePriceChange"
          value={formData.annualHousePriceChange}
          onChange={handleInputChange}
          prefix="%"
          ariaLabel="Annual house price change percentage"
        />
      </div>
    </div>
  );
};
